// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"28d6657a","652":"e6a920ce","730":"ace29559","811":"67d4d4b8","906":"e6a920ce","999":"a8e01bd0"}[chunkId] + ".chunk.css";
};